import React from 'react';
import { NavLink } from 'react-router-dom';

import { FaFacebookF, FaInstagram, FaTwitter } from 'react-icons/fa';

export default function Footer() {
	return (
		<div className='bottom'>
			<footer>
				<div className='footer-social'>
					<p>Follow us on social media</p>
					<div className='social-icons'>
						<a
							href='https://www.facebook.com/giordanospizza'
							target='_blank'
							rel='noreferrer'
						>
							<FaFacebookF />
						</a>
						<a
							href='https://www.instagram.com/giordanospizza/'
							target='_blank'
							rel='noreferrer'
						>
							<FaInstagram />
						</a>
						<a
							href='https://www.twitter.com/giordanospizza'
							target='_blank'
							rel='noreferrer'
						>
							<FaTwitter />
						</a>
					</div>
				</div>
				<div className='footer-nav'>
					<NavLink to='/'>home</NavLink>
					<NavLink to='/menu'>menu</NavLink>
					<NavLink to='/locations'>locations</NavLink>
				</div>
			</footer>
			<div className='footer-copy'>
				<h5>Giordano's &copy; 2021</h5>
				<p>All Rights Reserved</p>
			</div>
		</div>
	);
}
